<template>
  <div>
    <table-frame class="frame">
      <template #A1>
        <div class="block-avatar">
          <div class="avatar-box">
            <div class="avatar-content">
              <div class="avatar-border"></div>
              <transition name="el-fade-in">
                <img
                  v-if="!upload.imageURL || upload.loading"
                  src="./../../../assets/images/avatar-default.png"
                  class="avatar"
                />
              </transition>
              <transition name="el-fade-in">
                <img
                  v-if="!upload.loading && upload.imageURL"
                  :src="upload.imageURL"
                  class="avatar"
                />
              </transition>
              <transition name="el-fade-in">
                <el-progress
                  v-if="upload.loading"
                  type="circle"
                  :percentage="upload.percentage"
                  :show-text="false"
                  :width="86"
                  :stroke-width="1"
                ></el-progress>
              </transition>
            </div>
          </div>
          <el-upload
            accept="image/jpeg, image/png"
            :show-file-list="false"
            :headers="{ accessToken: appToken, appId: appId }"
            :action="upload.action"
            :multiple="false"
            :before-upload="handleBeforeUpload"
            :on-success="handleSuccess"
            :on-error="handleError"
          >
            <button class="btn-upload">更换头像</button>
          </el-upload>
        </div>
      </template>

      <template #B1>
        <div class="block">
          <div class="block-name">
            <span>姓名</span>
          </div>
          <el-input
            :placeholder="isReadonly ? '—' : '请输入'"
            v-model="info.name"
            :disabled="isReadonly"
            maxlength="6"
            clearable
          ></el-input>
        </div>
      </template>

      <template #C1>
        <div class="block">
          <div class="block-name">
            <span>性别</span>
          </div>
          <el-select
            v-model="info.gender"
            :disabled="isReadonly"
            :placeholder="isReadonly ? '—' : '请选择'"
          >
            <el-option
              v-for="item in genderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </template>
      <template #D1>
        <div class="block">
          <div class="block-name">
            <span>生日</span>
          </div>
          <el-date-picker
            v-model="info.birthday"
            type="date"
            :clearable="false"
            :disabled="isReadonly"
            :picker-options="pickerOptions"
            :placeholder="isReadonly ? '—' : '请选择'"
            suffix-icon="el-icon-date"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
      </template>
      <template #E1>
        <div class="block-btn">
          <button
            class="btn btn-edit"
            :class="{ 'btn-save': !isReadonly }"
            @click="handleClick"
          >
            <span v-if="isReadonly">修改</span>
            <span v-else>完成</span>
          </button>
        </div>
      </template>

      <template #A2>
        <div class="block-title">
          <span>账户设置</span>
        </div>
      </template>

      <template #B2>
        <div class="block">
          <div class="block-name">
            <span>邮箱</span>
          </div>
          <div class="block-content">
            <span>{{ userInfo.email }}</span>
          </div>
          <transition name="magic">
            <div
              class="block-operation"
              v-if="userInfo.userType == 2 && !isLocked"
            >
              <span class="setting" @click="showE = true">更换..</span>
            </div>
          </transition>
        </div>
      </template>

      <template #C2>
        <div class="block">
          <div class="block-name">
            <span>域账号</span>
          </div>
          <div class="block-content">
            <span>{{ userInfo.userAccount }}</span>
          </div>
          <transition name="magic">
            <div class="block-operation" v-if="!isLocked">
              <span class="setting" @click="showD = true">{{
                userInfo.userAccount ? '更换..' : '绑定..'
              }}</span>
            </div>
          </transition>
        </div>
      </template>

      <template #D2>
        <div class="block">
          <div class="block-name">
            <span>手机</span>
          </div>
          <div class="block-content">
            <span>{{ userInfo.phoneNo }}</span>
          </div>
          <transition name="magic">
            <div class="block-operation" v-if="!isLocked">
              <span class="setting" @click="showM = true">更换..</span>
            </div>
          </transition>
        </div>
      </template>

      <template #E2>
        <div class="block-btn">
          <button
            class="btn btn-edit"
            :class="{ 'btn-save': !isLocked }"
            @click="handleClick2"
          >
            <span v-if="isLocked">修改</span>
            <span v-else>完成</span>
          </button>
        </div>
      </template>

      <template #B3>
        <div class="block">
          <div class="block-name">
            <span>密码</span>
          </div>
          <div class="block-content">
            <span>***</span>
          </div>
          <transition name="magic">
            <div class="block-operation" v-if="!isLocked">
              <span class="setting" @click="showP = true">修改密码..</span>
            </div>
          </transition>
        </div>
      </template>

      <template #A4>
        <div class="block-title">
          <span>我的应用</span>
        </div>
      </template>
      <template #B4>
        <div class="block">
          <div class="block-app">
            <div class="block-name">
              <span>智慧建筑</span>
            </div>
            <div class="icon-app">
              <a :href="link.ib" target="_blank">
                <img src="./../../../assets/images/icon-ib.png" alt />
              </a>
            </div>
          </div>
          <div class="block-app">
            <div class="block-name">
              <span>云构平台</span>
            </div>
            <div class="icon-app">
              <a :href="link.ccc" target="_blank">
                <img src="./../../../assets/images/icon-ccc.png" alt />
              </a>
            </div>
          </div>
          <div class="block-app">
            <div class="block-name">
              <span>图形引擎</span>
            </div>
            <div class="icon-app">
              <a :href="link.me" target="_blank">
                <img src="./../../../assets/images/icon-me.png" alt />
              </a>
            </div>
          </div>
          <div class="block-app">
            <div class="block-name">
              <span>共享中心</span>
            </div>
            <div class="icon-app">
              <a :href="link.bp" target="_blank">
                <img src="./../../../assets/images/icon-bp.png" alt />
              </a>
            </div>
          </div>
        </div>
      </template>
    </table-frame>

    <card-l :visible.sync="showL" @unlock="doUnlock"></card-l>
    <card-e :visible.sync="showE" @update="doUpdate"></card-e>
    <card-d :visible.sync="showD" @update="doUpdate"></card-d>
    <card-m
      :visible.sync="showM"
      @unlock="doUpdate"
      @update="doUpdate"
    ></card-m>
    <card-p :visible.sync="showP" @unlock="doUpdate"></card-p>
  </div>
</template>

<script>
import tableFrame from './tableFrame.vue'
import { mapState } from 'vuex'
import cardL from './cardL.vue'
import cardE from './cardE.vue'
import cardD from './cardD.vue'
import cardM from './cardM.vue'
import cardP from './cardP.vue'
import aes from '@/uitls/aes'
import { getCookie } from '@/uitls/index'
import '@/assets/styles/modify.scss'

import mixinDriver from '@/components/mixinDriver'

export default {
  components: {
    tableFrame,
    cardL,
    cardE,
    cardD,
    cardM,
    cardP
  },
  mixins: [mixinDriver],
  data() {
    return {
      appToken: '',
      appId: '',
      sercurityCode: '',
      link: {
        ccc: process.env.CCC_TARGET,
        me: process.env.ME_TARGET,
        bp: process.env.BP_TARGET,
        ib: process.env.IB_TARGET
      },
      upload: {
        action: process.env.FDS_UPLOAD,
        imageURL: '',
        percentage: 0,
        loading: false
      },
      info: {
        name: '',
        gender: '',
        birthday: ''
      },

      isReadonly: true,
      isLocked: true,
      // unlock panel show/hide
      showL: false,
      showE: false,
      showD: false,
      showM: false,
      showP: false,

      timer: null,

      genderOptions: [{ value: 0, label: '男' }, { value: 1, label: '女' }],
      // data-picker disabled
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  methods: {
    doUploadStart() {
      this.upload.percentage = 0
      this.upload.loading = true
    },
    doUploadProgress(val) {
      this.upload.percentage = val
    },
    handleSuccess(res) {
      // cancel loading
      this.upload.loading = false
      let { code = -1, value = {}, message = '' } = res
      if (code === 200) {
        this.doUpdateAvatar({ userIcon: value.hashName })
      } else if (code === -1) {
        // cancelled
      } else {
        this.$message.warning(message)
      }
    },
    handleError() {
      // cancel loading
      this.upload.loading = false
    },
    // before upload
    handleBeforeUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        // this.$message.error('图片限于 JPG / PNG 格式')
        this.$eventHub.$emit('sendUpdate', {
          data: { code: 300, message: '图片限于 JPG / PNG 格式' }
        })
      }
      if (!isLt2M) {
        // this.$message.error('图片大小超过 2M')
        this.$eventHub.$emit('sendUpdate', {
          data: { code: 300, message: '图片大小超过 2M' }
        })
      }
      if ((isJPG || isPNG) && isLt2M) {
        return this.getFastDFSToken((appToken, appId) => {
          this.appToken = appToken
          this.appId = appId
        })
      } else {
        return false
      }
    },
    doUpdateAvatar(option) {
      this.$http
        .post('/user-server/user/updateUser', option)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message)
            this.doUpdate()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    // give up edit user info
    doGiveUp() {
      this.isReadonly = true
      this.info.name = this.userInfo.userName
      this.info.gender = this.userInfo.sex
      this.info.birthday = this.userInfo.birthday
    },
    doUpdate() {
      this.$emit('update')
    },
    doUpdateInfo() {
      this.$http
        .post('/user-server/user/updateUser', {
          userName: this.info.name,
          sex: this.info.gender,
          birthday: this.info.birthday
        })
        .then(res => {
          if (res.data.code == 200) {
            this.isReadonly = true
            this.doUpdate()
          }
          this.$eventHub.$emit('sendUpdate', res)
        })
        .catch(err => {
          console.log('ERROR', err)
        })
    },

    // counting down
    doCheck() {
      if (this.timer) return
      // get session
      let sessionData = sessionStorage.getItem('ACCOUNT_UNLOCK_DATA')
      if (!sessionData) {
        this.doLock()
        return
      }
      // get expire time from session
      let endTime = JSON.parse(sessionData).time || 0
      let nowTime = new Date().getTime()
      let gapTime = endTime - nowTime
      // buffer time 2000
      if (gapTime < 2000 || gapTime > 602000) {
        this.doLock()
        return
      }
      // set session data to vuex
      if (!this.$store.state.unlockData.code) {
        this.$store.commit('setUnlockData', {
          code: aes.Decrypt(JSON.parse(sessionData).code),
          time: endTime
        })
      }
      this.isLocked = false
      this.timer = setTimeout(() => {
        this.doLock()
      }, gapTime)
    },
    doUnlock() {
      this.doCheck()
    },
    doLock() {
      // incase unlock panel still there
      this.showL = false
      this.showE = false
      this.showD = false
      this.showM = false
      this.showP = false
      this.isLocked = true
      clearTimeout(this.timer)
      this.timer = null
      sessionStorage.removeItem('ACCOUNT_UNLOCK_DATA')
    },

    handleClick() {
      if (this.isReadonly) {
        this.isReadonly = false
      } else {
        // todo: check whether modified
        // update personal info
        this.doUpdateInfo()
      }
    },

    handleClick2() {
      this.doGiveUp()
      if (this.isLocked) {
        // show unlock panel
        this.showL = true
      } else {
        this.doLock()
      }
    },
    sendUpdate(result) {
      // 如果被iframe引用,那么发送通知
      if (this.$route.query.isMsg == 1) {
        let data = {}
        data.type = 'user_update'
        data.response = result
        window.parent.postMessage(JSON.stringify(data), '*')
      } else {
        if (result.data.code == 200) {
          this.$message.success(result.data.message)
        } else {
          this.$message.error(result.data.message)
        }
      }
    }
  },
  computed: {
    ...mapState(['userInfo']),
    actionData: function() {
      return {
        motion: 'unlock',
        phoneNo: this.userInfo.phoneNo
      }
    }
  },
  watch: {
    userInfo: function() {
      const ibSrc = process.env.IBSRC
      this.info.name = this.userInfo.userName
      this.info.gender = this.userInfo.sex
      this.info.birthday = this.userInfo.birthday
      this.upload.imageURL = this.userInfo.userIcon
        ? process.env.FDS_IMAGE + this.userInfo.userIcon
        : ''
    }
  },
  mounted: function() {
    this.doCheck()
    this.$eventHub.$on('sendUpdate', this.sendUpdate)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../styles/avatar.scss';

.magic-enter-active {
  transition: margin 0.2s ease-out, opacity 0.2s ease-in 0.1s;
}
.magic-leave-active {
  transition: margin 0.2s ease-out 0.1s, opacity 0.1s ease-in;
}
.magic-enter,
.magic-leave-to {
  margin-top: -20px;
  opacity: 0;
}

.block {
  padding: 12px;
  text-align: left;
}
.block-btn {
  padding-top: 9px;
}
.block-title {
  height: 20px;
  width: 140px;
  padding: 12px;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  color: #2f3035;
  text-align: center;
}
.block-name {
  height: 20px;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
}
.block-app {
  display: inline-block;
  width: 60px;
  text-align: center;
  margin-right: 50px;
  .icon-app {
    margin-top: 10px;
  }
  &:last-child {
    margin-right: 0;
  }
}
.block-content {
  height: 40px;
  font-size: 16px;
  line-height: 40px;
  color: #2f3035;
  overflow: hidden;
  text-overflow: ellipsis;
}
.block-operation {
  height: 20px;
  line-height: 20px;
}
.setting {
  font-size: 16px;
  color: #0081ff;
  cursor: default;
  box-sizing: border-box;
  border-bottom: solid 1px #fff;
  transition: border-color 0.12s ease-in;
}
.setting:hover {
  border-color: #0081ff;
}
.block-btn {
  text-align: center;

  .btn {
    display: inline-block;
    width: 48px;
    height: 26px;
    padding: 0;
    margin-bottom: 12px;
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    background-color: transparent;
    font-size: 12px;
    line-height: 24px;
    color: #404040;
    transition-property: background-color, border-color, color, opacity;
    transition-duration: 0.2s;

    -webkit-appearance: none;
    outline: none;
    -webkit-user-select: none;
  }
  .btn-edit {
    color: #404040;
    border-color: #ccc;
    &:hover {
      color: #0081ff;
      border-color: #0081ff;
    }
  }
  .btn-save {
    color: #fff;
    background-color: #0081ff;
    border-color: #0081ff;
    &:hover {
      color: #fff;
      opacity: 0.8;
    }
  }
}
</style>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/userInfo/components/blockOne.vue